import * as React from 'react';
import { TabsWidget } from './TabsWidget';

/**
 * Abstract class that defines common interface and functionality between tab activator modes
 */

export abstract class BaseTabActivator {
  protected tabsWidget: TabsWidget;

  public constructor(tabsWidget: TabsWidget) {
    this.tabsWidget = tabsWidget;
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  public abstract handleKeyDown(tabIndex: number, keyboardEvent: React.KeyboardEvent<HTMLDivElement>): void;

  protected tabIndexFromKeyDown(tabIndex: number, keyValue: string): number {
    const numTabs = this.tabsWidget.props.tabs.length;

    switch (keyValue) {
      // With the arrow keys, we wrap around. For example, if the last tab is focused or active and the
      // user keys down on the right arrow, we wrap around so that now the first tab is focused or active.
      case 'ArrowRight':
        return (tabIndex + 1) % numTabs;
      case 'ArrowLeft':
        return (numTabs + tabIndex - 1) % numTabs;
      case 'Home':
        return 0;
      case 'End':
        return numTabs - 1;
      default:
        return -1;
    }
  }

  protected static preventDefaultAndStopPropagation(event: React.KeyboardEvent<HTMLDivElement>): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
